import {
FaMoneyBillWave,
FaWallet,
FaGift
} from "react-icons/fa";

import {formatToman} from "../../utils/referralHelpers";

function Card({
title,
value,
icon,
highlight
}){

return(

<div
className={`rounded-[2rem]
border p-5 shadow-xl ${
highlight
?
"border-green-500/20 bg-green-500/10"
:
"border-white/10 bg-[#10182A]/90"
}`}
>

<div className="w-11 h-11 rounded-2xl bg-gradient-to-l from-purple-600 to-blue-500 flex items-center justify-center text-white">
{icon}
</div>

<div className="mt-4 text-sm text-slate-400">
{title}
</div>

<div className="mt-2 text-xl font-black text-white">
{value}
</div>

</div>

)

}

export default function ReferralStats({
totalEarned,
availableBalance,
pendingBalance
}){

return(

<section className="grid md:grid-cols-3 gap-4 mt-5">

<Card
title="کل درآمد"
value={formatToman(totalEarned)}
icon={<FaMoneyBillWave/>}
/>

<Card
title="قابل برداشت"
value={formatToman(availableBalance)}
icon={<FaWallet/>}
highlight
/>

<Card
title="در انتظار تایید"
value={formatToman(pendingBalance)}
icon={<FaGift/>}
/>

</section>

)

}